import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router';

import type { Route } from './+types/root';
import './app.css';
import { FormSaveAndNavigateProvider } from './contexts/FormSaveAndNavigateContext';
import { AppErrorBoundary } from './AppErrorBoundary';
import { getOrgSlug } from './utils/server/admin/getOrgSlug';
import type { RootHandle } from './hooks/useOrganization';

export const links: Route.LinksFunction = () => [
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous',
  },
  {
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
  },
];

export const loader = async ({ context, params }: Route.LoaderArgs) => {
  const orgSlug = getOrgSlug({ params, context });
  const hasCustomDomain = context.hasCustomDomain;

  return {
    orgSlug,
    hasCustomDomain,
  };
};

export const handle: RootHandle = {
  root: (match: any) => {
    return {
      orgSlug: match.data.orgSlug as string | undefined,
      hasCustomDomain: match.data.hasCustomDomain as boolean,
    };
  },
};

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body className="min-h-screen">
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return (
    <FormSaveAndNavigateProvider>
      <Outlet />
    </FormSaveAndNavigateProvider>
  );
}

export const ErrorBoundary = AppErrorBoundary;
